import Vue from 'vue'
import Vuex from 'vuex'
import sidebar from './modules/sidebar'
import settings from './modules/settings'

import auth from './auth'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    sidebar,
    settings
  }
})
